/**
 *
 * @module submitOrderWithCardPaymentMethodRequest
 *
 */

import Check from 'check-types';
import Services from './../services/entry';
import SubmitOrderWithPaymentMethodRequest from './submitOrderWithPaymentMethodRequest';

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    nonEmptyObject,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class SubmitOrderWithCardPaymentMethodRequest
 * @since 3.6.0
 * @desc Information necessary to place an order.
 *
 */
export default class SubmitOrderWithCardPaymentMethodRequest extends SubmitOrderWithPaymentMethodRequest {

    /**
     *
     * @param {Object} options
     * @param {Array<SDK.Commerce.LineItem>} options.lineItems
     * @param {String} options.paymentMethodId
     * @param {Array<SDK.Services.Commerce.OrderCampaign>} options.orderCampaigns
     * @param {String} options.emailAddress
     * @param {SDK.Services.Commerce.RedemptionRequest} [options.redemptionRequest=undefined]
     * @param {String} options.cardSecurityCode
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'SubmitOrderWithCardPaymentMethodRequest(options)',
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get cardSecurityCode() {
                return `${this.ctor} options.cardSecurityCode should be a String with length`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { cardSecurityCode } = options;

        nonEmptyString(cardSecurityCode, errorMessage.cardSecurityCode, InvalidArgumentException);

        super(options);

        /**
         *
         * @access public
         * @type {String}
         * @desc CVV in encrypted format in case of credit card. Required in case of CC payment.
         *
         */
        this.cardSecurityCode = cardSecurityCode;

    }

}



// WEBPACK FOOTER //
// ./src/commerce/submitOrderWithCardPaymentMethodRequest.js